import React from 'react';
import UserList from '../user-list/UserList';
import Heading from '@amzn/meridian/heading';

const USER_ROLES = [
  {
    name: 'TenantAdmin',
    display: 'Tenant Admin',
    tooltip:
      'allows to do all operations within tenant. This include create, read, edit, delete resources, workflows, users, lookups.',
  },
  {
    name: 'TenantWorkflowManager',
    display: 'Tenant Workflow Manager',
    tooltip: 'allows to create, read, edit, delete resources, workflows, lookups.',
  },
  {
    name: 'TenantUser',
    display: 'Tenant User',
    tooltip:
      'allows to translate text using workflow through debug tool and read-only access to resources and workflows.',
  },
];

const UserManager = () => {
  const lists = [];
  for (const key of USER_ROLES) {
    lists.push(<UserList group={key} key={key} />);
  }
  return (
    <div className="p-1">
      <Heading level={1}>User Manager</Heading>
      {lists}
    </div>
  );
};

export default UserManager;
